import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.1.0-alpha';

function clone(x){ return x==null?x:JSON.parse(JSON.stringify(x)); }
function normalizeRevision(value){
  const n=Number(value);
  return Number.isInteger(n) && n>=0 ? n : 0;
}
function nextRevision(current){ return normalizeRevision(current)+1; }
function stamp(record,currentRevision){
  if(!record || typeof record!=='object') throw new Error('RECORD_REQUIRED');
  const revision=nextRevision(currentRevision!=null?currentRevision:record.revision);
  return Object.freeze({...clone(record),revision});
}
function compareExpected(actual,expected){
  const a=normalizeRevision(actual), e=normalizeRevision(expected);
  if(a===e) return Object.freeze({ok:true,actual:a,expected:e,reason:'REVISION_MATCH'});
  return Object.freeze({ok:false,actual:a,expected:e,reason:'REVISION_CONFLICT'});
}
function mergeDecision(base,incoming,expectedRevision){
  if(!base){
    if(normalizeRevision(expectedRevision)!==0){
      return Object.freeze({allowed:false,reason:'CREATE_REVISION_CONFLICT',actualRevision:0,expectedRevision:normalizeRevision(expectedRevision)});
    }
    return Object.freeze({allowed:true,reason:'CREATE',nextRevision:1});
  }
  const check=compareExpected(base.revision,expectedRevision);
  if(!check.ok){
    return Object.freeze({allowed:false,reason:'REVISION_CONFLICT',actualRevision:check.actual,expectedRevision:check.expected});
  }
  return Object.freeze({allowed:true,reason:'UPDATE',nextRevision:check.actual+1});
}
function supabaseRevisionSQL(table){
  const safe=/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(table||'')?table:'research_states';
  return [
    `alter table public.${safe}`,
    `  add column if not exists revision bigint not null default 1;`,
    ``,
    `create index if not exists ${safe}_user_revision_idx`,
    `  on public.${safe}(user_id, revision);`
  ].join('\n');
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  ok('normalize missing revision to zero',normalizeRevision(null)===0);
  ok('normalize negative revision to zero',normalizeRevision(-1)===0);
  ok('normalize valid revision',normalizeRevision(4)===4);
  ok('next revision increments',nextRevision(4)===5);

  const s=stamp({symbol:'AAA',revision:2});
  ok('stamp increments embedded revision',s.revision===3);
  ok('stamp preserves payload',s.symbol==='AAA');

  const m=compareExpected(4,4);
  ok('matching revision accepted',m.ok===true&&m.reason==='REVISION_MATCH');

  const c=compareExpected(4,3);
  ok('mismatched revision rejected',c.ok===false&&c.reason==='REVISION_CONFLICT');

  const create=mergeDecision(null,{symbol:'AAA'},0);
  ok('new record starts at revision one',create.allowed===true&&create.nextRevision===1);

  const badCreate=mergeDecision(null,{symbol:'AAA'},2);
  ok('new record rejects stale nonzero expectation',badCreate.allowed===false&&badCreate.reason==='CREATE_REVISION_CONFLICT');

  const update=mergeDecision({revision:5},{symbol:'AAA'},5);
  ok('matching update advances revision',update.allowed===true&&update.nextRevision===6);

  const stale=mergeDecision({revision:5},{symbol:'AAA'},4);
  ok('stale writer is blocked',stale.allowed===false&&stale.actualRevision===5);

  const sql=supabaseRevisionSQL('research_states');
  ok('SQL adds revision column',sql.includes('revision bigint not null default 1'));
  ok('SQL adds revision index',sql.includes('user_revision_idx'));
  ok('unsafe table falls back',supabaseRevisionSQL('bad-name').includes('public.research_states'));

  ok('API has no trade signal',!('tradeSignal' in API));
  ok('API has no capital permission',!('capitalPermission' in API));

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,normalizeRevision,nextRevision,stamp,compareExpected,mergeDecision,supabaseRevisionSQL,selfTest};
global.ZooInvestResearchStateRevisionConcurrencyEngine=Object.freeze(API);
})(engineContext);